<template lang="pug">
  article.artigo-teste
    slot(name="loading")
    slot(name="header")
    slot(name="feedback")
    slot(name="content")
    slot(name="footer")
</template>

<style lang="scss">
  .artigo-teste {
    margin: 40px 0;

    > .texto {
      margin: 15px 0;

      .aligncenter {
        display: block;
        margin: 0 auto;
      }

      img {
        display: block;
        margin: 0 auto;
        max-width: 100%;
        height: auto;
      }

      figure {
        display: block;
        margin: 0 auto;

        > figcaption {
          padding: 7px 0;
          font-size: 85%;
          text-align: center;
        }
      }

      ul {
        li {
          padding: 3px 0;
        }
        li:before {
          display: inline-block;
          font: normal normal normal 14px/1 'FontAwesome';
          font-size: inherit;
          text-rendering: auto;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          content: '\f0da';
          color: $color-blue-dark;
          margin-right: 7px;
        }
      }
    }

    @include media(">=tablet") {
      > .texto {
        padding: 0 3rem;
        .alignleft {
          display: inline-block;
          float: left;
          margin-right: 15px;
          margin-bottom: 5px;
        }
        .alignright {
          display: inline-block;
          float: right;
          margin-left: 15px;
          margin-bottom: 5px;
        }
      }
    }

  }
</style>

<script>
export default {
  name: 'conteudo'
}
</script>



// WEBPACK FOOTER //
// Artigo.vue?5843412d